<div class="ag-shareholder-name-cell d-flex align-items-center gap-12">
  <i class="icon" [class]="iconClass"></i>

  <div>
    <ul class="list-unstyled mb-0">
      @for (holder of individualShareholders; track holder.relationshipId) {
        <li class="shareholder-name individual-shareholder-name">
          @if (displayPendingChanges
          && (holder.previousIndividualData?.fullNameLabel
            && holder.previousIndividualData?.fullNameLabel !== holder.individualData.fullNameLabel)) {
            <div class="red">{{ holder.previousIndividualData?.fullNameLabel }}</div>
            <div class="green">{{ holder.name }}</div>
          } @else {
            {{ holder.name }}
          }
        </li>
      }
    </ul>

    <ul class="list-unstyled mb-0">
      @for (holder of corporateShareholders; track holder.relationshipId) {
        <li class="shareholder-name">{{ holder.name }}</li>
      }
    </ul>
  </div>
</div>
